export default __webpack_public_path__ + "static/media/oladele.b725a648.png";